export default function BuildingsIcon() {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.6"
        d="M8.42496 3.83325C8.35829 4.08325 8.33329 4.35825 8.33329 4.66659V7.16659H4.16663V5.49992C4.16663 4.58325 4.91663 3.83325 5.83329 3.83325H8.42496Z"
        fill="currentColor"
      />
      <path
        d="M8.33329 16.3334V7.16675H4.16663C2.49996 7.16675 1.66663 8.00008 1.66663 9.66675V16.3334C1.66663 18.0001 2.49996 18.8334 4.16663 18.8334H10.8333C9.16663 18.8334 8.33329 18.0001 8.33329 16.3334ZM5.62496 14.6667C5.62496 15.0084 5.34163 15.2917 4.99996 15.2917C4.65829 15.2917 4.37496 15.0084 4.37496 14.6667V11.3334C4.37496 10.9917 4.65829 10.7084 4.99996 10.7084C5.34163 10.7084 5.62496 10.9917 5.62496 11.3334V14.6667Z"
        fill="currentColor"
      />
      <path
        opacity="0.4"
        d="M11.6667 18.8334H10.8334C9.16671 18.8334 8.33337 18.0001 8.33337 16.3334V4.66675C8.33337 3.00008 9.16671 2.16675 10.8334 2.16675H15.8334C17.5 2.16675 18.3334 3.00008 18.3334 4.66675V16.3334C18.3334 18.0001 17.5 18.8334 15.8334 18.8334H15"
        fill="currentColor"
      />
      <path
        d="M15 15.5001V18.8334H11.6666V15.5001C11.6666 15.0417 12.0416 14.6667 12.5 14.6667H14.1666C14.625 14.6667 15 15.0417 15 15.5001ZM11.6666 11.9584C11.325 11.9584 11.0416 11.6751 11.0416 11.3334V7.16675C11.0416 6.82508 11.325 6.54175 11.6666 6.54175C12.0083 6.54175 12.2916 6.82508 12.2916 7.16675V11.3334C12.2916 11.6751 12.0083 11.9584 11.6666 11.9584ZM15 11.9584C14.6583 11.9584 14.375 11.6751 14.375 11.3334V7.16675C14.375 6.82508 14.6583 6.54175 15 6.54175C15.3416 6.54175 15.625 6.82508 15.625 7.16675V11.3334C15.625 11.6751 15.3416 11.9584 15 11.9584Z"
        fill="currentColor"
      />
    </svg>
  );
}
